import { MEDIA, srcSet } from '../../generated/media';

type Props = {
  /** src/generated/media.ts içindeki anahtar, ör. "gallery/salon-01" */
  media: string;
  alt: string;
  /** <img sizes> — tarayıcının doğru genişliği seçmesi için */
  sizes: string;
  /** CLS'i önlemek için kullanılacak referans genişlik (yükseklik en-boy oranından hesaplanır) */
  width: number;
  className?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
  decoding?: 'async' | 'sync' | 'auto';
};

/**
 * AVIF + WebP servis eden, explicit width/height veren görsel bileşeni.
 * Kaynaklar `npm run media` ile üretilir.
 */
export function Picture({
  media,
  alt,
  sizes,
  width,
  className,
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
}: Props) {
  const entry = MEDIA[media];
  if (!entry) {
    if (import.meta.env.DEV) throw new Error(`Bilinmeyen medya anahtarı: ${media}`);
    return null;
  }

  const smallest = entry.widths[0];

  return (
    <picture>
      <source type="image/avif" srcSet={srcSet(media, 'avif')} sizes={sizes} />
      <img
        src={`/${entry.dir}/${entry.slug}-${smallest}.webp`}
        srcSet={srcSet(media, 'webp')}
        sizes={sizes}
        alt={alt}
        width={width}
        height={Math.round(width / entry.aspect)}
        loading={loading}
        // React 18 `fetchPriority` prop'unu tanımıyor ve sessizce düşürüyor —
        // yani öncelik ipucu HTML'e hiç yazılmıyordu. DOM'un beklediği küçük
        // harfli ad ile geçiyoruz. (React 19'da camelCase destekleniyor.)
        {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
        decoding={decoding}
        className={className}
      />
    </picture>
  );
}
